@if (nextStepRoute(); as route) {
  <a class="w-full" pButton [size]="size()" [routerLink]="route"><span pButtonLabel>{{ displayLabel() }}</span></a>
}
